export const hLineColor = (i: any, node: any) => (i === 0 || i === node.table.body.length) ? '#afafaf' : '#ececec'

export const vLineColor = (i: any, node: any) => (i === 0 || i === node.table.widths.length) ? '#afafaf' : '#ececec';

export const fillColor = (columnIndex: any) => columnIndex === 0 ? '#fe5000' : null;

export const quitVLineColor = (i: any, node: any) => (i === 0 || i === node.table.widths.length) ? '#fff' : '#ececec';


